import BusinessIcon from "@mui/icons-material/Business";
import { Box, Typography } from "@mui/material";
import React from "react";
import theme from "../../theme/theme";

const MeetingCompanyName = ({ company }) => {
  return (
    <Box display="flex" alignItems="center" mb={0}>
     
      <Typography variant="subtitle1" sx={{ color: theme.palette.gray.main }}>
         <BusinessIcon sx={{ marginRight: 1 ,verticalAlign:"sub"}} />
        {company}
        
      </Typography>
    </Box>
  );
};

export default MeetingCompanyName;
